import React, { useEffect, useRef, useState } from 'react'
import '../stylings/navbar.css'
import { Link } from 'react-router-dom'
import admissionForm from '../assest/admission_form.pdf'
import logo from '../assest/logo1.png'
import newGif from '../assest/newGif.gif'
import { MdOutlineStickyNote2 } from 'react-icons/md'
import { RiGraduationCapFill } from 'react-icons/ri'
import { FaAward } from 'react-icons/fa'

const Navbar = () => {

    const [isSticky, setIsSticky] = useState(false);
    const navbarRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const navbar = navbarRef.current;
            if (navbar) {
                if (window.scrollY >= navbar.offsetTop && !isSticky) {
                    setIsSticky(true);
                } else if (window.scrollY === 0 && isSticky) {
                    setIsSticky(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isSticky]);
    return (
        <nav className={isSticky ? "navbar navbar-expand-lg bg-body-tertiary sticky-top2 bounce" : 'navbar navbar-expand-lg bg-body-tertiary sticky-top2'} id='navbar' ref={navbarRef}>
            <div className="container-fluid">
                <div className="navbar-header">
                    <button className="navbar-toggler ms-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="schoolName-container d-lg-none">
                        <Link to='/'><img src={logo} alt="School-logo" /></Link>
                    </div>
                </div>

                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about-school" role="button">
                                About Us
                            </Link>
                            {/* <ul className="dropdown-menu">
                                <li><Link className="dropdown-item" to="/about-school">About School</Link></li>
                                <li><Link className="dropdown-item" to="/public-disclosure">Mandatory Public Disclosure</Link></li>
                                <li><Link className="dropdown-item" to="/cbse-mandatory-public-disclosure">CBSE Mandatory Disclosure</Link></li>
                            </ul> */}
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Academics
                            </Link>
                            <ul className="dropdown-menu">
                                <li><Link className="dropdown-item" to="#">Faculty</Link></li>
                                <li><Link className="dropdown-item" to="#">Fee Structure</Link></li>
                                <li><Link className="dropdown-item" to="#">Curriculum</Link></li>
                                <li><Link className="dropdown-item" to="#">PTM</Link></li>
                                <li><Link className="dropdown-item" to="#">Activities</Link></li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Student
                            </Link>
                            <ul className="dropdown-menu">
                                {/* <li><Link className="dropdown-item" to="#">Assignments</Link></li> */}
                                <li><Link className="dropdown-item" to="/syllabus">Syllabus</Link></li>
                                <li><Link className="dropdown-item" to="/time-table">Time Table</Link></li>
                                <li><Link className="dropdown-item" to="/noticeall">Notice</Link></li>
                                {/* <li><Link className="dropdown-item" to="/audionoticeall">Audio Announcement</Link></li> */}
                                <li><Link className="dropdown-item" to="/academic-calender">Academic Calender</Link></li>
                            </ul>
                        </li>
                        {/* <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="#">Achievements</Link>
                        </li> */}
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Gallery
                            </Link>
                            <ul className="dropdown-menu">
                                <li><Link className="dropdown-item" to="/galleryall">Photo Gallery</Link></li>
                                <li><Link className="dropdown-item" to="/videoall">Video Gallery</Link></li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="/contact">Contact Us</Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link active" target='_blank' aria-current="page" to={'/wtl_admissionform.pdf'}>Download Admission Form</Link>
                        </li>
                    </ul>
                    <div className="d-lg-none">
                        <div className="headerTop_Right">
                            <div className="ContBox-Container">
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <MdOutlineStickyNote2 />
                                    </div>
                                    <div className="ContBoxRight">
                                        <Link to="/public-disclosure" target="_blank" tabIndex="0">
                                            <div className="ContBoxHd">Public Disclosure</div>
                                            <div className="ContBoxContent">
                                                Click Here
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <FaAward />
                                    </div>
                                    <div className="ContBoxRight">
                                        <Link to="">
                                            <div className="ContBoxHd">Result 2025-26</div>
                                            <div className="ContBoxContent">
                                                Click Here
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="ContBox">
                                    <div className="ContBoxleft">
                                        <RiGraduationCapFill />
                                    </div>
                                    <div className="ContBoxRight">
                                        <Link>
                                            <div className="ContBoxHd">Admission</div>
                                            <div className="ContBoxContent">
                                                Registration Open 2025-2026
                                            </div>
                                            <div className="img-container">
                                                <img src={newGif} alt="new gif" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </nav>
    )
}

export default Navbar
